<template>
  <nav class="mui-toolbar">
    <div :class="titlebarClassnames">
      <CMButton v-bind="nav" v-if="nav" :id="nav.id"></CMButton>
      <div class="mui-toolbar__title" ref="title">
        {{title}}
        <slot name="title"></slot>
      </div>
      <div v-if="spacer" class="mui-layout__spacer"></div>
      <div class="mui-toolbar__actions">
        <slot></slot>
      </div>
      <slot name="more"></slot>
    </div>
    <progressive-background
      :src="src"
      :placeholder="placeholder"
      :blur="placeholder.startsWith('blob:') ? 0 : 30"
      class="mui-toolbar__background"
      v-if="placeholder || src" />
    <div class="mui-toolbar__row" v-if="$slots['bottom-row']">
      <slot name="bottom-row"></slot>
    </div>
  </nav>
</template>

<script>
import MUIMenu from './MUIMenu'
import CMButton from './CMButton'

export default {
  props: {
    background: String,
    nav: {
      type: [Object, Boolean],
      required: false
    },
    placeholder: String,
    src: String,
    title: String,
    spacer: {
      type: Boolean,
      default: false
    }
  },
  components: {
    MUIMenu,
    CMButton
  },
  computed: {
    titlebarClassnames () {
      return {
        'mui-toolbar__row': true,
        'mui-toolbar__titlebar': true,
        'mui-toolbar__titlebar--prominent': this.placeholder || this.src
      }
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.mui-toolbar
  background: #fff
  border-bottom: 1px solid #e5e5e5
  color: $toolbarColor
  top: 0
  user-select: none
  width: 100%
  .mui-dialog--context &
    padding-top: 0
  &.mui-toolbar--transparent
    background: transparent
    border-bottom: 1px solid transparent
  &.mui-toolbar--fixed
    position: fixed
    z-index: 1000
  &.mui-toolbar--inline
    margin: 0
  &.mui-toolbar--prominent
    color: #fff
    background-color: #f4f5f6
    border-bottom: none
.mui-appbar
  background: $appBarBackground
  border-bottom: 1px solid $appBarBorderBottomColor
  color: $appBarColor
.mui-toolbar__row
  align-items: center
  display: flex
  height: 60px
  padding: 0 24px
  > .cm-button
    margin: 0 8px 0 0
  .mui-toolbar--inline &
    padding-left: 0
    padding-right: 0
.mui-toolbar__titlebar.mui-toolbar__titlebar--prominent
  background-image: linear-gradient(to bottom,rgba(0,0,0,0.40) 0%,transparent)
.mui-toolbar__nav
  cursor: pointer
  flex: 0 0 36px
  font-size: 24px
  font-style: normal
  margin-left: -2px
  margin-top: -4px
  text-align: left
  width: 44px
.mui-toolbar__title
  flex: 1 1 auto
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  input
    background: transparent
    border: 0
    outline: 0
    padding: 0
    margin: 0
.mui-toolbar__title, .mui-toolbar__title input
  font-family: $uiFontFamily
  font-size: 20px
  font-weight: $uiFontWeight
  letter-spacing: $uiFontLetterSpacing
  .mui-theme--dark &
    color: #ffffff
.mui-toolbar__actions
  flex: 0 0 auto
  white-space: nowrap
.mui-toolbar__actions > div
  margin-left: 8px
.device__mode--webview
  .mui-toolbar--app
    padding-top: 20px
.mui-layout__spacer
  flex-grow: 1
.mui-toolbar__background
  position: absolute!important
  top: 0
  z-index: -1
.mui-toolbar__actions #processing
  &:before
    content: ''
    box-sizing: border-box
    display: inline-block
    position: absolute
    top: 50%
    left: 10px
    width: 20px
    height: 20px
    margin-top: -10px
    margin-left: 0
    border-radius: 50%
    border: 2px solid transparent
    border-top-color: #181d23
    animation: spinner .6s linear infinite
    padding-left: 8px
    .mui-theme--dark &
      border-top-color: #ffffff
  span
    display: none
.mui-toolbar:after
  content: ''
  display: block
  position: absolute
  top: $toolbarHeight
  left: 0
  right: 0
  height: 10px
  opacity: 0
  pointer-events: none
  box-shadow: inset 0 4px 4px -5px rgba(0, 0, 0, 0.24)
  transition: all $sheetSpeed/2 $animationTimingFunction
  z-index: 1
.mui-toolbar:after
  .is-scrolled &
    opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/CMToolbar.vue